export class InviteDetails {
	username!: string;
	timeZone!: string;
}
